import { makeStyles } from "@material-ui/core/styles";
export var useStyles = makeStyles(function (theme) { return ({
    root: {
        width: "100%"
    },
    paper: {
        marginTop: theme.spacing(3),
        width: "100%",
        overflowX: "auto",
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 650
    },
    headerRow: {
        background: theme.palette.primary.light,
        "& .MuiTableCell-head": {
            color: theme.palette.primary.contrastText
        }
    },
    nestedRow: {
        paddingLeft: theme.spacing(5),
        background: '#e4f2f2',
        '&>div': {
            marginBottom: '5px'
        },
        '& textarea, input': {
            boxShadow: 'none'
        }
    },
    formField: {
        height: '100%',
        '& .MuiInputBase-root, textarea': {
            height: '100%'
        }
    },
    expandedRow: {
        background: '#e4f2f2',
        "& .MuiTableCell-root": {
            borderBottom: "none"
        }
    },
    wrenchIcon: {
        transform: "rotateZ(90deg)"
    },
    downloadIcon: {
        transform: "rotateZ(180deg)"
    },
    templateIcons: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    tableRow: {
        cursor: 'pointer'
    }
}); });
//# sourceMappingURL=table.js.map